<template>
  <div class="mb-5">
    <div class="box" v-if="!paid">
      <OrderArticle :item="item" />
    </div>
    <div v-if="paid">
      <div class="box" v-for="voucher in item.vouchers" :key="voucher.id" id="order-item">
        <div v-if="canceled" class="notification is-danger has-text-weight-bold" role="alert" aria-live="assertive">
          {{ $t('notices.order-has-been-cancelled') }}
        </div>
        <section style="position:relative;">
          <article class="columns is-multiline">
            <div class="column is-2">
              <p class="image order-image">
                <img
                  :src="`https://assets.urlaubsgutschein.kaufen/i/resize?width=150&quality=50&interlace=true&type=auto&file=${item.image}`"
                  :srcset="
                    `https://assets.urlaubsgutschein.kaufen/i/resize?width=150&quality=50&interlace=true&type=auto&file=${item.image} 150w,
                      https://assets.urlaubsgutschein.kaufen/i/resize?width=300&quality=50&interlace=true&type=auto&file=${item.image} 300w,
                      https://assets.urlaubsgutschein.kaufen/i/crop?width=700&height=394&gravity=smart&quality=50&interlace=true&type=auto&file=${item.image} 700w`
                  "
                  sizes="(max-width: 768px) 100vw,
                   10vw"
                  :alt="item.title"
                  loading="lazy"
                />
              </p>
            </div>
            <div class="column is-10">
              <div class="columns is-vcentered">
                <div class="column is-8">
                  <b-tag type="is-danger" v-if="voucher.fulfilled" class="is-uppercase">{{ $t('general.printed') }}</b-tag>
                  <b-tag type="is-danger" v-if="voucher.returned" class="is-uppercase">{{ $t('general.cancelled') }} {{ new Date(voucher.return.returnedOn) | dateFormat('DD.MM.YYYY') }}</b-tag>
                  <span v-if="voucher.generated">
                    {{ $t('general.voucher') }}
                    <strong>{{ voucher.idSstItem }}</strong>
                  </span>
                  <div class="has-text-weight-semibold">{{ item.title }}</div>
                  <p class="u-text--ellipsis">
                    <small>{{ item.subtitle }}</small>
                  </p>
                  <div class="u-text--ellipsis">
                    <small>{{ item.description }}</small>
                  </div>
                </div>
                <div class="column is-4 is-size-5 has-text-right">
                  <strong>{{ item.currency | currency }} {{ item.unitPrice | amount }}</strong
                  ><br />
                  <b-button v-if="!canceled && !voucher.returned" type="is-dark" @click="openVoucher(voucher)">
                    {{ $t('general.voucher') }} {{ $t('general.print') }}
                    <span class="is-sr-only"> : {{ item.title }} </span>
                  </b-button>
                  <!-- <br v-if="item.hasInvoice" />
                  <b-button v-if="item.hasInvoice" type="is-dark" @click="openInvoice(item)" class="mt-4">{{ $t('general.invoice') }} {{ $t('general.print') }}</b-button> -->
                </div>
              </div>

              <!-- VERSICHERUNG START -->
              <div v-if="!voucher.returned && voucher.hasInsurance">
                <div v-for="upgrade in getInsuranceUpgradesRelatedTo(voucher)" :key="upgrade.id">
                  <div class="columns is-vcentered">
                    <div class="column is-8">
                      {{ upgrade.description }}<strong class="is-inline-block">({{ item.currency | currency }} {{ upgrade.unitPrice | amount }})</strong>
                    </div>
                  </div>

                  <b-notification v-if="!voucher.insurancePolicy" role="status" aria-live="polite" type="is-info" aria-close-label="Close notification" :closable="false">
                    <p class="title is-size-5 is-marginless">{{ $t('notices.submit-insurance') }}</p>
                    <p>{{ $t('notices.voucher-insruance-data-missing') }}</p>
                    <b-button size="is-small" type="is-info" class="mt-4" inverted outlined @click="toggleInsurance">{{ $t('notices.submit-insurance') }}</b-button>
                  </b-notification>

                  <b-notification v-if="voucher.insurancePolicy" type="is-success" role="status" aria-live="polite" aria-close-label="Close notification" :closable="false">
                    <p class="title is-size-5">{{ $t('notices.insurance-data-sent') }}</p>
                    {{ $t('notices.insurance-policy-via-mail') }}
                  </b-notification>

                  <!-- VERSICHERUNG COLLAPSE START -->
                  <b-collapse :open="isInsuranceOpen" aria-id="contentInsurance" :class="'insurance_' + item.id">
                    <hr />
                    <article>
                      <h1 class="title is-size-4 has-text-centered">{{ $t('notices.submit-insurance') }}</h1>
                      <Insurance :upgrade="upgrade" :id="voucher.idSstItem" :orderId="orderId" :token="token" @data-sent="insuranceSuccess" />
                    </article>
                  </b-collapse>
                  <!-- VERSICHERUNG COLLAPSE ENDE -->
                </div>
                <!-- VERSICHERUNG END -->
              </div>
            </div>
          </article>

          <b-loading :is-full-page="false" :active.sync="!voucher.generated" :can-cancel="false">
            <b-notification type="is-info" aria-close-label="Close notification" role="status" aria-live="polite">
              <!-- <b-icon pack="fas" icon="sync-alt" size="is-large" custom-class="fa-spin"></b-icon> -->
              {{ $t('notices.vouchers-are-beeing-generated') }}
            </b-notification>
          </b-loading>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import Insurance from './Insurance'
import OrderArticle from '@/components/OrderArticle'
export default {
  name: 'OrderItem',
  components: {
    Insurance,
    OrderArticle,
  },
  props: {
    item: Object,
    paid: Boolean,
    canceled: Boolean,
    orderId: String,
    token: String,
  },
  data() {
    return {
      isInsuranceOpen: false,
      isInsuranceSent: false,
    }
  },
  methods: {
    openVoucher(voucher) {
      this.$emit('voucher-selected', voucher)
    },
    async openInvoice(orderItem) {
      this.$emit('invoice-download', orderItem)
    },
    getInsuranceUpgradesRelatedTo(voucher) {
      if (this.item && voucher) {
        return this.item.upgrades.filter(f => f.planID != null || f.unitPrice == 0)
      }
      return []
    },
    insuranceSuccess(voucherId) {
      this.isInsuranceSent = true
      this.isInsuranceOpen = false

      this.item.vouchers
        .filter(f => f.idSstItem === voucherId)
        .forEach(element => {
          element.insurancePolicy = 'intermediate'
        })
      // this.$scrollTo('#order-item', 500, {
      //   offset: -160,
      // })
    },
    toggleInsurance() {
      this.isInsuranceOpen = !this.isInsuranceOpen
      this.$scrollTo(`.insurance_${this.item.id}`, 500, {
        offset: -200,
      })
    },
  },
}
</script>

<style scoped lang="scss">
.order-image {
  position: sticky;
  top: 7rem;
}
</style>
